import classNames from 'classnames';
import Page from '../../components/Layout/Page';
import { getPageContent } from '../../api/pagesApi';
import { genShareConfig } from '../../components/Share/use-config-share';
import { serverSideTranslation } from '../../util/next';
import NewsGroup from '../../components/NewsGroup';
import styles from './Algorithm.module.scss';
import { Decoration } from '../../modules/HomeBanner/Decoration';
import ArrowBtn from '../../components/ArrowBtn';
import RefuteFeedback from '../../modules/RefuteFeedback';

const homeMoImg = 'https://p0.meituan.net/smartvenus/226d7534be373471a80440202a20cc2264014.png';
const homeCenterPcImg = 'https://s3plus.meituan.net/smart/halfbg2.svg';
const homeCenterPcHoverImg = 'https://s3plus.meituan.net/smart/pc-bg.svg';
const homeLeftImg = 'https://s3plus.meituan.net/smart/left-trans.svg';
const homeRightImg = 'https://s3plus.meituan.net/smart/right2.svg';

const RefuteRumors = (props: any) => {
  const { _nextI18Next: i18n, pageContentData } = props;
  const { shareContent = {}, pageContent = {} } = pageContentData || {};
  const description =
    shareContent.shareDetail || '美团将秉持公开透明原则，回应外部质疑，严厉打击虚假谣言，维护良好网络生态环境。';
  const title = shareContent.shareTitle || '辟谣公告';
  const linkText = shareContent.linkText || '进入辟谣新闻';
  const linkUrl = shareContent.linkUrl || '/newsroom/refute-news';
  const { pageTitle, groupDataList, feedbackData } = pageContent;
  const {
    feedbackTitle = '不实信息举报专区',
    feedbackDesc = '发现涉美团和骑手、商家等相关方的不实信息？点击填写反馈，我们将尽快核实处理',
    feedbackBtnText = '填写反馈',
    feedbackUrl = '',
    feedbackDecorationImgPc = '',
    feedbackDecorationImgH5 = '',
  } = feedbackData;

  return (
    <Page description={description} title={title}>
      <div className="w-full bg-[#f7f8f9]">
        <section
          className={classNames(styles['newsroom-banner-box'], 'pt-15 xl:pt-20')}
          style={
            {
              '--auto-bg': `url(${homeMoImg})`,
              '--1024-bg': `url(${homeCenterPcImg})`,
              '--1024-hover-bg': `url(${homeCenterPcHoverImg})`,
            } as any
          }
        >
          <h1 className="mt-font mx-auto w-[303px] pt-[70px] text-center text-[24px] font-normal leading-[38px] text-[#111111] md:w-[908px] md:pt-[104px] md:text-[36px] md:leading-[56px]">
            {pageTitle}
          </h1>
          <Decoration className={styles.newsroomBannerLeft} lg={homeLeftImg} xl={homeLeftImg} />
          <Decoration className={styles.newsroomBannerRight} lg={homeRightImg} xl={homeRightImg} />
        </section>
        <RefuteFeedback
          title={feedbackTitle}
          desc={feedbackDesc}
          btnText={feedbackBtnText}
          linkUrl={feedbackUrl}
          decorationImgPc={feedbackDecorationImgPc}
          decorationImgH5={feedbackDecorationImgH5}
        />
        <div className="bg-white-homebg pb-[60px] md:pb-[90px]">
          {groupDataList?.map((item: any, index: number) => {
            return <NewsGroup key={index} lanType={i18n.initialLocale} {...item} />;
          })}

          <div className="flex justify-center pt-6 lg:pt-10">
            <ArrowBtn linkVal={linkText} linkUrl={linkUrl} linkOut />
          </div>
        </div>
      </div>
    </Page>
  );
};

export async function getServerSideProps({ locale, query }: any) {
  const pageContentParams = {
    uri: '/newsroom/refute-rumors',
    pageContentNo: query.pageContentNo,
    preview: query.preview,
  };
  const pageContentData = await getPageContent(pageContentParams, locale);
  return {
    props: {
      lxCustom: {
        cid: 'c_donation_4i5ekl8e',
        locale,
        ...pageContentData?.shareContent,
      },
      pageContentData,
      ...genShareConfig(pageContentData),
      ...(await serverSideTranslation(locale, ['contactus', 'cookie', 'common'])),
    },
  };
}

export default RefuteRumors;
